<template>
  <button
    class="record-btn"
    :class="{ 'is-recording': isRecording }"
    @mousedown="startRecording"
    @mouseup="stopRecording"
    @mouseleave="cancelRecording"
    @touchstart.prevent="startRecording"
    @touchend.prevent="stopRecording"
    @touchcancel.prevent="cancelRecording"
    :disabled="disabled || remainPoints < 1 || !isSupport"
  >
    <span class="icon" v-show="!isRecognition">🎤</span>

    <span v-show="!isRecording && !isRecognition">按住說話</span>

    <span v-show="isRecording && !isRecognition">錄音中...</span>

    <span v-show="isRecognition">分析發音中...</span>
  </button>
</template>

<script>
import api from '@/store/api'
import Recorder from 'js-audio-recorder'
import { mapGetters } from 'vuex'

let recorder = new Recorder()

export default {
  name: 'AiRecordButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    sText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isSupport: true,
      isRecording: false,
      isRecognition: false,
      count: 16,
      timer: null,
      recordStartTime: 0
    }
  },
  computed: {
    ...mapGetters(['remainPoints'])
  },
  mounted() {
    this.getPermission();
  },
  beforeDestroy() {
    recorder.destroy().then(() => {
      recorder = null;
    });
  },
  methods: {
    getPermission() {
      Recorder.getPermission().then(() => {
        this.isSupport = true;
      }, (error) => {
        this.isSupport = false;
        console.error('無法取得麥克風權限:', error);
      });
    },

    startRecording() {
      if (this.isRecording) return;

      if (!this.isSupport) {
        console.warn('尚未取得麥克風權限或瀏覽器不支援');
        return;
      }

      if (this.disabled || this.remainPoints < 1) {
        if (this.remainPoints < 1) this.swal_failPopPoints('點數不足');
        return;
      }

      // 👉 移到這裡！一按下去馬上計時
      this.recordStartTime = Date.now();
      this.isRecording = true;
      let time = 0;

      recorder.start().then(() => {
        this.countDown();
      }).catch((error) => {
        console.error('錄音啟動失敗:', error);
        this.isRecording = false;
      });

      recorder.onprogress = (params) => {
        if (params.vol <= 10) {
          time++;
        } else {
          time = 0;
        }
        if (time >= 35) {
          this.stopRecording();
        }
      };
    },

    stopRecording() {
      if (!this.isRecording) return;

      // 先不管時間夠不夠，都先把錄音狀態跟倒數停掉
      recorder.stop();
      this.isRecording = false;
      clearInterval(this.timer);
      this.count = 16;

      // 👉 計算按下去到放開的時間差
      const duration = Date.now() - this.recordStartTime;

      // 如果小於 500 毫秒，擋住不打 API
      if (duration < 500) {
        console.warn('錄音時間太短，不發送 API');
        this.$swal.fire({
          icon: 'info',
          title: '錄音時間太短',
          text: '請「按住」按鈕直到您說完句子喔！',
          timer: 2000,
          showConfirmButton: false
        });
        return; // 在這裡中斷，就不會往下執行 getSTT 了！
      }

      // 時間夠長，才拿 Blob 打 API
      const audioBlob = recorder.getWAVBlob();
      this.getSTT(audioBlob);
    },

    stopRecording() {
      if (!this.isRecording) return;

      recorder.stop();
      this.isRecording = false;

      clearInterval(this.timer);
      this.count = 16;

      // 👉 計算錄音時長 (毫秒)
      const duration = Date.now() - this.recordStartTime;

      // 如果錄不到 0.5 秒 (500 毫秒)，視為不小心按到，不送 API
      if (duration < 500) {
        console.warn('錄音時間太短，不發送 API');

        this.$swal.fire({
          icon: 'info',
          title: '錄音時間太短',
          text: '請「按住」按鈕直到您說完句子喔！',
          timer: 2000, // 兩秒後自動關閉
          showConfirmButton: false
        });

        return; // 直接中斷，不執行後面的 getSTT
      }

      // 如果時間夠長，才拿 Blob 打 API
      const audioBlob = recorder.getWAVBlob();
      this.getSTT(audioBlob);
    },

    cancelRecording() {
      if (this.isRecording) {
        this.stopRecording();
      }
    },

    getSTT(audioData) {
      let path = `/ai/ers?`;
      if (this.sText) {
        path += `&stext=${encodeURIComponent(this.sText)}`;
      }
      this.isRecognition = true;

      api.post(path, audioData, {
        headers: {
          'Content-Type': audioData.type || 'audio/wav',
          'showLoading': false
        }
      })
      .then((response) => {
        this.$store.dispatch('getRemainPoints');
        this.$emit('record-complete', response.data);
      })
      .catch((error) => {
        console.error('ERS 辨識失敗', error);
        this.swal_failPopUp();
      })
      .finally(() => {
        this.isRecognition = false;
      });
    },

    countDown() {
      this.timer = setInterval(() => {
        this.count--;
        if (this.count <= -1) {
          this.stopRecording();
        }
      }, 1000);
    },

    // ✂️ 整個 drawRecord() 與 drawWave() 方法已刪除

    swal_failPopPoints(text) {
      let defaultTitle = text ? `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`;
      this.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          htmlContainer: 'remainPoints_swal my-3',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      });
    },

    swal_failPopUp(text) {
      let defaultTitle = text ? `<h3>${text}</h3><p>請洽客服人員加購點數</p>` : `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p>`;
      this.$swal.fire({
        html: defaultTitle,
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          popup: 'p-0',
          header: 'swal-header',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      });
    }
  }
}
</script>

<style scoped>
/* 這裡只放按鈕專屬的 CSS */
.record-btn {
  flex: 1;
  background: #1c7ed6;
  color: white;
  border: none;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  user-select: none;
  -webkit-touch-callout: none;
}
.record-btn.is-recording {
  background: #d9480f;
  transform: scale(0.98);
}
.record-btn:disabled {
  background: #adb5bd;
  cursor: not-allowed;
}
</style>
